import { triggerAPI, qs } from './util';

const checkoutRewardsFormDetails = document.querySelector(
    '.checkout-rewards-form-details'
  ),
  MID = document.querySelector('.MID'),
  MIDerror = document.querySelector('.MIDerror');

checkoutRewardsFormDetails.classList.add('hide');
MIDerror.classList.add('hide');

function renderToggleForm(e) {
  const currentValue = e.target.value;
  if (currentValue === 'Yes') {
    checkoutRewardsFormDetails.classList.remove('hide');
    MID.classList.remove('hide');
  } else if (currentValue === 'No') {
    checkoutRewardsFormDetails.classList.remove('hide');
    MID.classList.add('hide');
    document.forms['checkout-rewards-form'].MID.value = '';
  } else {
    checkoutRewardsFormDetails.classList.add('hide');
  }
}

function handleFormSubmit(e) {
  const visaSafeClickForm = document.forms['checkout-rewards-form'];
  e.preventDefault();
  let isFormSubmit = false,
    huspotPayload = {
      fields: [
        {
          name: 'razorpay_user',
          value: `${visaSafeClickForm.isExistingCustomer.value}`
        },
        {
          name: 'mid',
          value: visaSafeClickForm.MID.value && `${visaSafeClickForm.MID.value}`
        },
        {
          name: 'full_name',
          value: `${visaSafeClickForm.name.value}`
        },
        {
          name: 'signup_contact_mobile',
          value: `${visaSafeClickForm.phone.value}`
        },
        {
          name: 'email',
          value: `${visaSafeClickForm.email.value}`
        },
        {
          name: 'company',
          value: `${visaSafeClickForm.company.value}`
        },
        {
          name: 'website',
          value: `${visaSafeClickForm.website.value}`
        },
        {
          name: 'company_turn_over',
          value: `${visaSafeClickForm.companyturnover.value}`
        }
      ],
      context: {
        pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
        pageName: 'Razorpay Checkout Rewards'
      },
      legalConsentOptions: {
        consent: {
          // Include this object when GDPR options are enabled
          consentToProcess: true,
          text:
            'I agree to allow Razorpay to store and process my personal data.',
          communications: [
            {
              value: true,
              subscriptionTypeId: 6760497,
              text: 'I agree to receive marketing communications from Razorpay.'
            }
          ]
        }
      }
    };

  if (visaSafeClickForm.isExistingCustomer.value === 'Yes') {
    if (visaSafeClickForm.MID.value === '') {
      MIDerror.classList.remove('hide');
      isFormSubmit = false;
    } else {
      isFormSubmit = true;
    }
  } else if (visaSafeClickForm.isExistingCustomer.value === 'No') {
    isFormSubmit = true;
  }

  if (isFormSubmit) {
    MIDerror.classList.add('hide');
    triggerAPI(
      'https://api.hsforms.com/submissions/v3/integration/submit/5558946/2691700d-a775-4d77-bde8-a05e86921703',
      'POST',
      response => {
        qs('.after-success').classList.add('show');
        qs('.checkout-rewards-form').classList.add('hide');
      },
      huspotPayload
    );
  }
}

qs('#checkout-rewards-modal #is-existing-customer').addEventListener(
  'change',
  renderToggleForm
);

qs('.checkout-rewards-form').addEventListener('submit', handleFormSubmit);
